<template>
  <master-layout pageTitle="SMS">
    <div>
      <div v-if="!smsConnected" class="gridMargin">
        <div class="model-sections">
          <div class="cust-brdr sectionPadding">
            <div class="flex-start alignCenter gap10P">
              <img src="@/resources/images/sms_logo.svg" class="smsLogo" alt="sms_logo" width="40"/>
              <p class="vtext-card-title">Connect SMS</p>
            </div>
          </div>
          <div class="sectionPadding">
            <div class="optionsContainer cust_brdr">
              <div class="flex-between width100P vpb-10">
                <div class="flex-start">
                  <p class="vtext-subtitle">Sender ID <span class="important">*</span></p>
                  <HelpTooltip>
                    <ul>
                      <li>Alphanumeric (MAX - 11 characters) or numeric (MAX - 15 digits) only</li>
                      <li>Cannot include the leading + or 00</li>
                      <li>You can add up to 30 Sender IDs for your account. Please ensure each Sender ID complies with your country's telecom regulations.</li>
                      <li>Sender ID must include 3 to 11 characters, and follow one of the options below: </li>
                      <li>Numeric only - includes numbers 0-9, special characters are not allowed</li>
                      <li>Alphanumeric or Alphabetic - includes numbers 0-9, upper and lower-case letters and some special characters (space, comma, hyphen and underscore). ASCII special characters (e.g. #, @) are not allowed.</li>
                    </ul>
                  </HelpTooltip>
                </div>
                <div>
                  <p class="senderKeysTotal">{{ senderKeysArray.length + '/30' }}</p>
                </div>
              </div>
              <!-- Sender keys List max 30 -->
              <div v-if="senderKeysArray.length > 0" class="senderContainer vmb-10">
                <div class="sender-row sender-header">
                  <div class="sender-cell"><span class="vtext-subtitle">ID</span></div>
                  <div class="sender-cell text-right"><span class="vtext-subtitle">Set as default</span></div>
                  <div class="sender-cell text-right"><span class="vtext-subtitle">Action</span></div>
                </div>
                <div v-for="(item, index) in senderKeysArray" :key="index" class="sender-row">
                  <div class="sender-cell"><span class="vtext-body">{{ item.id }}</span></div>
                  <div class="sender-cell text-right">
                    <VSwitch
                      :checked="item.isDefault"
                      @change="(e) => { if (e.target.checked) setAsDefault(index, false); }"
                      connotation="cta"
                      :disabled="senderKeysArray.filter(i => i.isDefault).length === 1 && item.isDefault"
                    ></VSwitch>
                  </div>
                  <div class="sender-cell text-right">
                    <VIcon name="delete-line" connotation="alert" class="trashIcon cursorPointer" :disabled="senderKeysArray.filter(i => i.isDefault).length === 1 && item.isDefault" @click="removeSenderID(item.id)"></VIcon>
                  </div>
                </div>
              </div>
              <div class="flex-start width100P gap10P">
                <VTextField v-model="senderID" placeholder="Enter sender ID" :maxlength="15" aria-label="SenderID" appearance="ghost" class="vivid-input" @keyup.enter="addSenderkeys(false)"></VTextField>
                <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Add" :disabled="!senderID.length || senderKeysArray.length == 30" @click="addSenderkeys(false)"></VButton>
              </div>
            </div>
            <div class="margin10P">
              <div class="vrow vmb-20">
                <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin custPaddingRight">
                  <p class="vtext-subtitle vpb-10">API key<span class="important">*</span></p>
                  <VTextField v-model="apikey" placeholder="Enter API key" aria-label="API key" appearance="ghost" class="vivid-input"></VTextField>
                </div>
                <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin">
                  <p class="vtext-subtitle vpb-10">API secret<span class="important">*</span></p>
                  <VTextField v-model="apisecret" placeholder="Enter API secret" aria-label="API secret" appearance="ghost" class="vivid-input"></VTextField>
                </div>
              </div>
              <div class="vrow vmb-20">
                <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin custPaddingRight">
                  <p class="vtext-subtitle vpb-10">App ID<span class="important">*</span></p>
                  <VTextField v-model="appid" placeholder="Enter App ID" aria-label="App ID" appearance="ghost" class="vivid-input"></VTextField>
                </div>
                <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12 colMargin">
                  <p class="vtext-subtitle vpb-10">App name<span class="important">*</span></p>
                  <VTextField v-model="appname" placeholder="Enter App name" aria-label="App name" appearance="ghost" class="vivid-input"></VTextField>
                </div>
              </div>
              <div class="vmb-20">
                <p class="vtext-subtitle vpb-10">Private key <span class="important">*</span></p>
                <VTextArea v-model="privatekey" aria-label="private key" placeholder="Enter Private key" appearance="ghost" class="vivid-textarea"></VTextArea>
              </div>
            </div>
            <VButton class="vvd-btn-primary vvd-btn-block" connotation="cta" appearance="filled" label="Submit" :disabled="disabled" @click="connectSMS"></VButton>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="channel-container gridMargin">
          <div class="cust_brdr optionsContainer flexContainer">
            <div class="flexContainer">
              <div class="channel-icon-wrap">
                <img src="../../../resources/images/sms_logo.svg" width="40" alt="sms_logo" class="iconImg"/>
                <VerificationBadge
                  class="channel-verification-badge"
                  :verified="isChannelVerified('sms')"
                  :error-message="verificationErrorFor('sms')"
                />
              </div>
              <h2 class="vtext-card-title">{{ smsSocialData?.appname || smsSocialData?.account_name }}</h2>
            </div>
            <VButton class="vvd-btn-danger-outline" connotation="announcement" appearance="outlined" label="Disconnect" @click="() => disconnectPageMode = true"></VButton>
          </div>
          <div>
            <div class="flexContainer vmb-20 cust_brdr optionsContainer">
              <div class="flex-start">
                <p class="vtext-subtitle">Webhook</p>
                <HelpTooltip>
                  A portion of the webhook has been masked for security purposes. If you need access to the full details, please raise a ticket to request them.
                </HelpTooltip>
              </div>
              <span class="vtext-body">{{ webhookToShow || '-' }}</span>
            </div>
            <div class="optionsContainer cust_brdr">
              <p class="vtext-subtitle vpb-10">Private key</p>
              <div class="flex-between gap10P">
                <VTextArea v-model="updatedPrivateKey" aria-label="private key" placeholder="Enter Private key" appearance="ghost" class="vivid-textarea"></VTextArea>
                <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Update" :disabled="!updatedPrivateKey" style="height: 40px;" @click="updatePrivateKey"></VButton>
              </div>
            </div>
            <div>
              <div class="flex-between width100P vpb-10">
                <div class="flex-start">
                  <p class="vtext-subtitle">Sender ID <span class="trashIcon">*</span></p>
                  <HelpTooltip :style="{'--offset-x': '20px', '--width': '20%'}" :iconStyle="{'padding-top': '1px'}">
                    <div class="tooltip-content">
                      <ul>
                        <li>Alphanumeric (MAX - 11 characters) or numeric (MAX - 15 digits) only</li>
                        <li>Cannot include the leading + or 00</li>
                        <li>You can add up to 30 Sender IDs for your account.</li>
                        <li>Sender ID must include 3 to 11 characters</li>
                        <li>Numeric only - includes numbers 0-9, special characters are not allowed</li>
                        <li>Alphanumeric or Alphabetic - includes numbers 0-9, upper and lower-case letters and some special characters (space, comma, hyphen and underscore). ASCII special characters (e.g. #, @) are not allowed.</li>
                      </ul>
                    </div>
                  </HelpTooltip>
                </div>
                <div>
                  <p class="senderKeysTotal">{{ senderKeysArray.length + '/30' }}</p>
                </div>
              </div>
              <!-- Sender keys List max 30 -->
              <div v-if="senderKeysArray.length > 0" class="senderContainer vmb-10">
                <div class="sender-row sender-header">
                  <div class="sender-cell"><span class="vtext-subtitle">ID</span></div>
                  <div class="sender-cell text-right"><span class="vtext-subtitle">Set as default</span></div>
                  <div class="sender-cell text-right"><span class="vtext-subtitle">Actions</span></div>
                </div>
                <div v-for="(item, index) in senderKeysArray" :key="index" class="sender-row cust-brdr">
                  <div class="sender-cell"><span class="vtext-body">{{ item.id }}</span></div>
                  <div class="sender-cell text-right">
                    <VSwitch
                      :checked="item.isDefault"
                      @change="(e) => { if (e.target.checked) setAsDefault(index, true); }"
                      connotation="cta"
                      :disabled="senderKeysArray.filter(i => i.isDefault).length === 1 && item.isDefault"
                    ></VSwitch>
                  </div>
                  <div class="sender-cell text-right">
                    <VIcon name="delete-line" connotation="alert" class="trashIcon cursorPointer" :disabled="senderKeysArray.filter(i => i.isDefault).length === 1 && item.isDefault" @click="deleteSenderID(item.id)"></VIcon>
                  </div>
                </div>
              </div>
              <div class="flex-start width100P gap10P">
                <VTextField v-model="senderID" placeholder="Enter sender ID" :maxlength="15" aria-label="SenderID" appearance="ghost" class="vivid-input"></VTextField>
                <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Add" :disabled="!senderID.length || senderKeysArray.length == 30" @click="addSenderkeys(true)"></VButton>
              </div>
            </div>
          </div>
        </div>
        <div class="gridMargin">
          <div class="vcol vcol--no-padding vcol-xl-6 vcol-lg-6 vcol-md-6 vcol-sm-12 vcol-xs-12">
            <button class="cardContainer" type="button" @click="$router.push('/sales-channel/sms/compliance-keywords')">
              <div class="cardContent">
                <img v-if="isDarkMode" src="../../../resources/images/compliance-keywords_dark.svg" width="40" alt="compliance_keywords" class="imgIcons"/>
                <img v-else src="../../../resources/images/compliance-keywords.svg" width="40" alt="compliance_keywords" class="imgIcons"/>
                <div>
                  <p class="vtext-card-title vpb-5">Compliance keywords</p>
                  <p class="vtext-subtitle">Set keywords that let users opt in or out receiving notifications.</p>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Disconnect Confirmation Dialog -->
    <VDialog :open="disconnectPageMode" headline="Are you sure?" modal @close="disconnectPageMode = false">
      <template #body>
        <p class="vtext-body">You want to disconnect your SMS account?</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="disconnectPageMode = false"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="disconnectSMS"></VButton>
      </template>
    </VDialog>

    <!-- Delete Sender ID Confirmation Dialog -->
    <VDialog :open="showDeleteConfirmation" headline="Are you sure?" modal @close="showDeleteConfirmation = false; deleteSMSid = ''">
      <template #body>
        <p class="vtext-body">You want to remove sender ID</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="showDeleteConfirmation = false; deleteSMSid = ''"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="updateSenderID"></VButton>
      </template>
    </VDialog>

    <!-- Reconnect Confirmation Dialog -->
    <VDialog :open="showReconnectDialog" headline="Reconnect Account" modal @close="showReconnectDialog = false">
      <template #body>
        <p class="vtext-body">This appears to be previously disconnected account, connecting this will show the data associated with that connection. Do you want to proceed?</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="No" @click="showReconnectDialog = false"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="reconnectSMS"></VButton>
      </template>
    </VDialog>
  </master-layout>
</template>

<script>
import apiInterceptor from '@/shared/apiInterceptor';
import HelpTooltip from '@/components/HelpTooltip.vue';
import VerificationBadge from '@/components/VerificationBadge.vue';
import { useUIStore } from '@/stores/ui';
import { useSocialChannels } from '@/composables/useSocialChannels';
import { useConnectionVerification } from '@/composables/useConnectionVerification';
import { environment } from '@/shared/env';
import { useAuthStore } from '@/stores/auth';

export default {
  components: { HelpTooltip, VerificationBadge },
  setup() {
    const { smsConnected, smsSocialData } = useSocialChannels();
    // Verify only this channel via ?channels=sms
    const { isChannelVerified, verificationErrorFor, refreshChannel, invalidateChannel } = useConnectionVerification(['sms']);
    return { smsConnected, smsSocialData, isChannelVerified, verificationErrorFor, refreshChannel, invalidateChannel };
  },
  data() {
    return {
      senderID: '',
      appid: '',
      appname: '',
      apikey: '',
      apisecret: '',
      privatekey: '',
      webhookToShow: "",
      disconnectPageMode: false,
      showReconnectDialog: false,
      senderKeysArray: [],
      showDeleteConfirmation: false,
      deleteSMSid: '',
      updatedPrivateKey: ''
    }
  },
  mounted() {
    try {
      if(this.smsConnected){
        const url = new URL(this.smsSocialData.webhook);
        url.hostname = 'XXXXXXXXXX';
        this.webhookToShow = url.href;
        this.managerSenderIds();
      }
    } catch (error) {
      console.error(error);
    }
  },
  computed: {
    isDarkMode() { return useUIStore().isDarkMode; },
    disabled() {
      return !this.senderKeysArray.length || !this.apikey.length || !this.apisecret.length || !this.appid.length || !this.appname.length || !this.privatekey.length;
    }
  },
  methods: {
    async connectSMS() {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Connecting SMS account...' });
        const defaultSender = this.senderKeysArray.find(item => item.isDefault)?.id || null;
        let reqBody = {
          sender_ids: this.senderKeysArray.map(item => item.id),
          applicationid: this.appid,
          appname: this.appname,
          apikey: this.apikey,
          apisecret: this.apisecret,
          privatekey: this.privatekey,
          default_sender_id: defaultSender,
          confirm: false
        }
        const response = await apiInterceptor.post(environment("VUE_APP_API_URL") + "social/v1/sms", reqBody );
        
        if(response.data === null && response.dialogMessage){
          useUIStore().updateLoading({ isLoading: false });
          this.showReconnectDialog = true;
          return;
        }
        
        useUIStore().updateToast({ open: true, message: "Your SMS account is now connected!", type: "success" });
        
        // Dispatch custom event to refresh LiveChatHome customers
        const refreshEvent = new CustomEvent("refresh-customers", {
          detail: { 
            action: "connect",
            channel: "sms",
            timestamp: new Date().toISOString()
          }
        });
        document.dispatchEvent(refreshEvent);
        
        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        await useAuthStore().checkToken();
        // Credentials just changed — re-check the verification status.
        await this.refreshChannel('sms');
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong", type: "danger" })
      } finally{
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async disconnectSMS() {
      try {
        this.disconnectPageMode = false;
        useUIStore().updateLoading({ isLoading: true, message: 'Disconnecting SMS account...' });
        await apiInterceptor.delete(environment("VUE_APP_API_URL") + "social/v1/sms" );
        useUIStore().updateToast({ open: true, message: "Your SMS Account is now disconnected!", type: "success" });
        // Disconnected channels are never verified — clear the status locally.
        this.invalidateChannel('sms');
        this.resetData();
        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        await useAuthStore().checkToken();
        
        // Dispatch custom event to refresh LiveChatHome customers
        const refreshEvent = new CustomEvent("refresh-customers", {
          detail: { 
            action: "disconnect",
            channel: "sms",
            timestamp: new Date().toISOString()
          }
        });
        document.dispatchEvent(refreshEvent);
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong", type: "danger" })
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    resetData() {
      this.senderID = '';
      this.appid = '';
      this.appname = '';
      this.apikey = '';
      this.apisecret = '';
      this.privatekey = '';
      this.webhookToShow = "";
      this.senderKeysArray = [];
    },
    validateSenderID(senderID) {
      // Numeric only: numbers 0-9, no special characters, no leading + or 00, up to 15 digits
      const numericPattern = /^[1-9][0-9]{0,14}$/;
      
      // Alphanumeric or Alphabetic: 0-9, a-z, A-Z, and only space, comma, hyphen, underscore
      // No ASCII special characters like #, @, etc.
      const alphanumericPattern = /^[a-zA-Z0-9 ,_-]{1,11}$/;

      if (numericPattern.test(senderID)) {
        return { valid: true, type: 'numeric' };
      }
      
      if (alphanumericPattern.test(senderID)) {
        return { valid: true, type: 'alphanumeric' };
      }

      return { valid: false };
    },
    async addSenderkeys(shouldCallAPI) {
      const trimmedSenderID = this.senderID.trim();
      const validation = this.validateSenderID(trimmedSenderID);
      if (!validation.valid) {
        useUIStore().updateToast({ 
          open: true, 
          message: "Invalid sender ID. Numeric only (max 15 digits) or Alphanumeric (space, comma, hyphen, underscore, max 11 characters). Special characters like #, @ are not allowed.", 
          type: "danger", 
          duration: 5000 
        });
        return;
      }
      if (trimmedSenderID) {
        // Check for duplicate
        const alreadyExists = this.senderKeysArray.some(item => item.id === trimmedSenderID);
        if (alreadyExists) {
          useUIStore().updateToast({ open: true, message: "Sender ID already exists.", type: "danger", duration: 2500 });
          return;
        }
        const isFirstEntry = this.senderKeysArray.length === 0;
        this.senderKeysArray.push({ 
          id: trimmedSenderID, 
          isDefault: isFirstEntry // First added entry becomes default
        });
        this.senderID = ""; // Clear input after adding
      }
      if(shouldCallAPI){
        await this.updateSms(false);
      }
    },
    async updateSms(isdelete) {
      try {
        useUIStore().updateLoading({ isLoading: true, message: isdelete ? 'Deleting sender ID...' : 'Updating SMS account...' });
        const defaultSender = this.senderKeysArray.find(item => item.isDefault)?.id || null;
        let reqBody = {
          sender_ids: this.senderKeysArray.map(item => item.id),
          default_sender_id: defaultSender
        }
        await apiInterceptor.patch(environment("VUE_APP_API_URL") + "social/v1/sms/" + this.smsSocialData.id, reqBody );
        let toastMessage = isdelete ? 'Sender ID deleted successfully!' : 'Your SMS account details are updated successfully!';
        useUIStore().updateToast({ open: true, message: toastMessage, type: "success" });
        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        await useAuthStore().checkToken();
        // Connection details just changed — re-check the verification status.
        await this.refreshChannel('sms');
      } catch (error) {
        this.removeSenderID(this.senderID);
        useUIStore().updateToast({ open: true, message: error.message || "Something went wrong", type: "danger" })
      } finally{
        this.deleteSMSid = "";
        useUIStore().updateLoading({ isLoading: false });
        this.senderID = "";
      }
    },
    setAsDefault(index, isUpdateSMS) {
      // Prevent deselecting the last default toggle
      if (this.senderKeysArray.filter(i => i.isDefault).length === 1 && this.senderKeysArray[index].isDefault) {
        return;
      }
      this.senderKeysArray.forEach((item, i) => {
        item.isDefault = i === index; // Ensure only one is default
      });
      if(isUpdateSMS){
        this.updateSms(false);
      }
    },
    removeSenderID(id) {
      const wasDefault = this.senderKeysArray.find(item => item.id === id)?.isDefault;
      this.senderKeysArray = this.senderKeysArray.filter(item => item.id !== id);
      if (wasDefault && this.senderKeysArray.length > 0) {  // If the removed item was default, set the first item (if any) as default
        this.senderKeysArray[0].isDefault = true;
      }
    },
    managerSenderIds() {
      if (this.smsSocialData?.sender_ids?.length) {
        const defaultId = this.smsSocialData.default_sender_id;
        const newSenderKeys = this.smsSocialData.sender_ids.map((id) => ({
          id,  
          isDefault: id === defaultId, // Set true if it matches the default_sender_id
        }));

        // Fallback: If default_sender_id doesn't match any, set the first one as default
        if (!newSenderKeys.some(item => item.isDefault)) {
          newSenderKeys[0].isDefault = true;
        }
        this.senderKeysArray = newSenderKeys;
      }
    },
    deleteSenderID(id){
      this.deleteSMSid = id;
      this.showDeleteConfirmation = true;
    },
    updateSenderID() {
      this.showDeleteConfirmation = false;
      this.removeSenderID(this.deleteSMSid);
      this.updateSms(true);
    },
    async updatePrivateKey() {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Updating private key...' });
        if (!this.updatedPrivateKey) {
          return useUIStore().updateToast({
            open: true,
            message: "Private key cannot be empty",
            type: "danger"
          })
        }
        let reqBody = {
          privatekey: this.updatedPrivateKey,
				}
        await apiInterceptor.patch(environment("VUE_APP_API_URL") + `social/v1/sms/${this.smsSocialData.id}`, reqBody );
        useUIStore().updateToast({
          open: true,
          message: "Private key updated successfully!",
          type: "success"
        });
        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        await useAuthStore().checkToken();
        // Credentials just changed — re-check the verification status.
        await this.refreshChannel('sms');
      } catch (error) {
        console.error(error);
        useUIStore().updateToast({
          open: true,
          message: "Failed to update key",
          type: "danger"
        });
      } finally {
        this.updatedPrivateKey = '';
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async reconnectSMS() {
      try {
        this.showReconnectDialog = false;
        useUIStore().updateLoading({ isLoading: true, message: 'Reconnecting SMS account...' });
        const defaultSender = this.senderKeysArray.find(item => item.isDefault)?.id || null;
        let reqBody = {
          sender_ids: this.senderKeysArray.map(item => item.id),
          applicationid: this.appid,
          appname: this.appname,
          apikey: this.apikey,
          apisecret: this.apisecret,
          privatekey: this.privatekey,
          default_sender_id: defaultSender,
          confirm: true
        }
        await apiInterceptor.post(environment("VUE_APP_API_URL") + "social/v1/sms", reqBody );
        
        useUIStore().updateToast({ open: true, message: "Your SMS account is now connected!", type: "success" });
        
        // Dispatch custom event to refresh LiveChatHome customers
        const refreshEvent = new CustomEvent("refresh-customers", {
          detail: { 
            action: "connect",
            channel: "sms",
            timestamp: new Date().toISOString()
          }
        });
        document.dispatchEvent(refreshEvent);
        
        // Re-fetch the connections list and mirror it into the auth store.
        await useAuthStore().refreshSocialConnections();
        await useAuthStore().checkToken();
        // Credentials just changed — re-check the verification status.
        await this.refreshChannel('sms');
      } catch (error) {
        useUIStore().updateToast({ open: true, message: error.message || "Failed to reconnect account", type: "danger" })
      } finally{
        useUIStore().updateLoading({ isLoading: false });
      }
    }
  }
}
</script>

<style scoped>
.model-sections {
  background: var(--white);
  border-radius: 5px;
}
.senderKeysTotal {
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--black);
  margin: 0;
}
.channel-container {
  background: var(--white);
  border-radius: 5px;
  padding: 20px;
}
.flexContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}
.iconImg {
  width: 40px;
  height: 40px;
}
.channel-icon-wrap {
  position: relative;
  display: inline-block;
  line-height: 0;
}
.channel-verification-badge {
  position: absolute;
  top: -6px;
  right: -6px;
}
.senderContainer {
  border-top: 1px solid var(--background-primary);
  padding-top: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}
.senderContainer::-webkit-scrollbar {
  width: 3px;
}
.sender-row {
  display: grid;
  grid-template-columns: 3fr 2fr 1fr;
  align-items: center;
  padding: 10px 0;
}
.sender-header {
  border-bottom: 1px solid var(--background-primary);
  padding-bottom: 15px;
  margin-bottom: 10px;
}
.sender-cell {
  min-width: 0;
}
.text-right {
  text-align: right;
}
.cardContainer {
  min-height: 90px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  background: var(--white);
  border: 1px solid var(--white);
  box-shadow: none;
  margin: 0;
  width: 100%;
  padding: 15px 20px;
  text-align: left;
  font: inherit;
  outline: none;
  transition: border-color 0.2s;
}
.cardContainer:hover {
  border-color: var(--purple);
}
.cardContainer:focus-visible {
  outline: 2px solid var(--purple);
  outline-offset: 2px;
}
.cardContent {
  display: flex;
  align-items: center;
  width: 100%;
}
.imgIcons {
  margin-right: 20px;
  flex-shrink: 0;
}
.vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}
.vivid-textarea {
  background: var(--background-primary);
  border-radius: 5px;
  width: 100%;
}
.custPaddingRight {
  padding-right: 20px;
}
.colMargin {
  margin-bottom: 10px;
}
.margin10P{
  margin: 10px;
}
@media only screen and (max-width: 760px) {
  .custPaddingRight {
    padding-right: 0px;
  }
  .cardContainer {
    margin: 10px 0;
  }
}
</style>
